import { render, staticRenderFns } from "./Template252.vue?vue&type=template&id=6d42d0c0"
import script from "./Template252.vue?vue&type=script&lang=js"
export * from "./Template252.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports